import React, { useEffect, useState } from "react";
import { Image, ScrollView, Text, View } from "react-native";
import { TouchableOpacity } from "react-native-gesture-handler";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { AppImages } from "../../utility/AppImages";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { AppColors } from "../../utility/AppColors";
import Separator from "../Separator";
import { CommonButton } from "../../common/CommonButton";
import RtmpStepsSlider from "./RtmpStepsSlider";

const RtmpSetupTooltip = ({ setRtmpTooltip }) => {
  const styles = useStyles();
  const deviceSize = useDeviceSize();
  const [userOS, setUserOS] = useState("");

  const [modalVisible, setModalVisible] = useState(false);
  const [selectedStep, setSelectedStep] = useState(null);

  const openModal = (step) => {
    setSelectedStep(step);
    setModalVisible(true);
  };

  const checkUserOS = () => {
    let userAgent = window.navigator.userAgent,
      platform = window.navigator.platform,
      macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"],
      windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"],
      iosPlatforms = ["iPhone", "iPad", "iPod"],
      os = null;

    if (macosPlatforms.indexOf(platform) !== -1) {
      os = "Mac OS";
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = "iOS";
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = "Windows";
    } else if (/Android/.test(userAgent)) {
      os = "Android";
    } else if (!os && /Linux/.test(platform)) {
      os = "Linux";
    }

    return os;
  };

  useEffect(() => {
    setUserOS(checkUserOS());
  }, []);

  return (
    <View
      style={{
        backgroundColor: AppColors.purple_453B50,
        borderRadius: 10,
        height:
          deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
            ? "85%"
            : 550,
        margin:
          deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
            ? 10
            : 0,
        overflow: "hidden",
      }}
    >
      <ScrollView
        showsVerticalScrollIndicator={false}
        contentContainerStyle={{ padding: 12, gap: 12 }}
      >
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Text style={[AppFontStyle.BOLD_ANYBODY_16, {}]}>
            How to Install RTMP Outputs Plugin
          </Text>
          <TouchableOpacity onPress={() => setRtmpTooltip(false)}>
            <Image
              source={AppImages.icCloseWhiteSvg}
              style={{
                width: 24,
                height: 24,
              }}
              resizeMode="contain"
            />
          </TouchableOpacity>
        </View>
        <View
          style={{
            borderColor: AppColors.black_18151b,
            borderRadius: 12,
            borderWidth: 1,
            gap: 12,
            padding: 12,
          }}
        >
          <Text style={AppFontStyle.SEMIBOLD_ANYBODY_16}>
            I don't have RTMP Outputs Plugin
          </Text>
          <View style={{ gap: 12 }}>
            {userOS === "Windows" ? (
              <CommonButton
                title="Window download"
                onTap={() => {
                  window.open(
                    "https://obsproject.com/forum/resources/multiple-rtmp-outputs-plugin.964/",
                    "_blank"
                  );
                }}
                buttonStyle={{
                  paddingVertical: 10,
                  paddingHorizontal: 14,
                  backgroundColor: AppColors.appViolentColor_6D08C3,
                  borderRadius: 8,
                  shadowOpacity: 0,
                  borderWidth: 2,
                  borderColor: AppColors.appViolentColor_6D08C3,
                  flex: 0.5,
                }}
                fontStyle={
                  deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM
                    ? AppFontStyle.SEMIBOLD_ANYBODY_12
                    : AppFontStyle.SEMIBOLD_ANYBODY_16
                }
                image={true}
                imageUrl={AppImages.icDownload}
                imageStyle={{ width: 20, height: 20 }}
              />
            ) : (
              <CommonButton
                title="Mac download"
                onTap={() => {
                  window.open(
                    "https://obsproject.com/forum/resources/multiple-rtmp-outputs-plugin.964/",
                    "_blank"
                  );
                }}
                buttonStyle={{
                  paddingVertical: 10,
                  paddingHorizontal: 14,
                  backgroundColor: AppColors.appViolentColor_6D08C3,
                  borderRadius: 8,
                  shadowOpacity: 0,
                  borderWidth: 2,
                  borderColor: AppColors.appViolentColor_6D08C3,
                  flex: 0.5,
                }}
                fontStyle={
                  deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM
                    ? AppFontStyle.SEMIBOLD_ANYBODY_12
                    : AppFontStyle.SEMIBOLD_ANYBODY_16
                }
                image={true}
                imageUrl={AppImages.icDownload}
                imageStyle={{ width: 20, height: 20 }}
              />
            )}
          </View>
        </View>
        <Separator
          color={AppColors.black_2D2733}
          height={1}
          marginTop={0}
          marginBottom={0}
          marginHorizontal={0}
        />
        <Text style={AppFontStyle.SEMIBOLD_ANYBODY_16}>
          Click the "Download Plugin" Button:
        </Text>

        {/* step 1 */}
        <View style={{ gap: 12 }}>
          <View style={{ flexDirection: "row", gap: 7 }}>
            <Text style={styles.tooltipStepText}>Step: 1</Text>
            <Text style={styles.tooltipStepHeader}>
              Open OBS and navigate to the top left tab. Click on 'Tools'.
            </Text>
          </View>
          <Separator
            color={AppColors.black_2D2733}
            height={1}
            marginTop={0}
            marginBottom={0}
            marginHorizontal={0}
          />
        </View>

        {/* step 2*/}
        <View style={{ gap: 12 }}>
          <View style={{ flexDirection: "row", gap: 7 }}>
            <Text style={styles.tooltipStepText}>Step: 2</Text>
            <Text style={styles.tooltipStepHeader}>Download the Plugin</Text>
          </View>
          <Text style={styles.tooltipText}>
            Locate the downloaded file on your device. and install the RTMP
            Output plugin into your system
          </Text>
          <Separator
            color={AppColors.black_2D2733}
            height={1}
            marginTop={0}
            marginBottom={0}
            marginHorizontal={0}
          />
        </View>

        {/* step 3 */}
        <View style={{ gap: 12 }}>
          <View style={{ flexDirection: "row", gap: 7 }}>
            <Text style={styles.tooltipStepText}>Step: 3</Text>
            <Text style={styles.tooltipStepHeader}>
              {" "}
              Set Up the Plugin in OBS
            </Text>
          </View>

          {/* 1 */}
          <View style={{ flexDirection: "row", gap: 7 }}>
            <Text style={styles.tooltipText}>1.</Text>
            <Text style={styles.tooltipText}>
              Open OBS Studio on your device
            </Text>
          </View>

          {/* 2 */}
          <View style={{ gap: 12 }}>
            <View style={{ flexDirection: "row", gap: 7 }}>
              <Text style={styles.tooltipText}>2.</Text>
              <Text style={styles.tooltipText}>
                On the top left menu, go to Dock and select Multiple Output from
                the dropdown.
              </Text>
            </View>
            <TouchableOpacity onPress={() => openModal(1)}>
              <Image
                source={AppImages.icRTMP1}
                style={{
                  width: 238,
                  height: 70,
                  position: "relative",
                }}
                resizeMode="contain"
              />{" "}
              <Image
                source={AppImages.icArrowExpandRound}
                style={{
                  width: 20,
                  height: 20,
                  position: "absolute",
                  left: 10,
                  bottom: 10,
                  tintColor: "#FFFFFF", // Ensure the arrow is white
                }}
                resizeMode="contain"
              />
            </TouchableOpacity>
          </View>

          {/* 3 */}
          <View style={{ gap: 12 }}>
            <View style={{ flexDirection: "row", gap: 7 }}>
              <Text style={styles.tooltipText}>3.</Text>
              <Text style={styles.tooltipText}>
                A new window for Multiple RTMP Outputs will appear.
              </Text>
            </View>
            <TouchableOpacity onPress={() => openModal(2)}>
              <Image
                source={AppImages.icRTMP2}
                style={{
                  width: 189,
                  height: 206,
                  position: "relative",
                }}
                resizeMode="contain"
              />{" "}
              <Image
                source={AppImages.icArrowExpandRound}
                style={{
                  width: 20,
                  height: 20,
                  position: "absolute",
                  left: 10,
                  bottom: 10,
                  tintColor: "#FFFFFF", // Ensure the arrow is white
                }}
                resizeMode="contain"
              />
            </TouchableOpacity>
          </View>
        </View>

        <Separator
          color={AppColors.black_2D2733}
          height={1}
          marginTop={0}
          marginBottom={0}
          marginHorizontal={0}
        />

        {/* step 4 */}
        <View style={{ gap: 12 }}>
          <View style={{ flexDirection: "row", gap: 7 }}>
            <Text style={styles.tooltipStepText}>Step: 4</Text>
            <Text style={styles.tooltipStepHeader}>Add a New Target</Text>
          </View>

          {/* 1 */}
          <View style={{ gap: 12 }}>
            <View style={{ flexDirection: "row", gap: 7 }}>
              <Text style={styles.tooltipText}>1.</Text>
              <Text style={styles.tooltipText}>
                In the Multiple RTMP Outputs window, click on Add New Target
                from the left pane.
              </Text>
            </View>
            <TouchableOpacity onPress={() => openModal(3)}>
              <Image
                source={AppImages.icRTMP3}
                style={{
                  width: 234,
                  height: 169,
                  position: "relative",
                }}
                resizeMode="contain"
              />{" "}
              <Image
                source={AppImages.icArrowExpandRound}
                style={{
                  width: 20,
                  height: 20,
                  position: "absolute",
                  left: 10,
                  bottom: 10,
                  tintColor: "#FFFFFF", // Ensure the arrow is white
                }}
                resizeMode="contain"
              />
            </TouchableOpacity>
          </View>

          {/* 2 */}
          <View style={{ gap: 12 }}>
            <View style={{ flexDirection: "row", gap: 7 }}>
              <Text style={styles.tooltipText}>2.</Text>
              <Text style={styles.tooltipText}>
                You’ll see fields for entering the URL and Stream Key.
              </Text>
            </View>
            <TouchableOpacity onPress={() => openModal(4)}>
              <Image
                source={AppImages.icRTMP4}
                style={{
                  width: 240,
                  height: 208,
                  position: "relative",
                }}
                resizeMode="contain"
              />{" "}
              <Image
                source={AppImages.icArrowExpandRound}
                style={{
                  width: 20,
                  height: 20,
                  position: "absolute",
                  left: 10,
                  bottom: 10,
                  tintColor: "#FFFFFF", // Ensure the arrow is white
                }}
                resizeMode="contain"
              />
            </TouchableOpacity>
          </View>
        </View>

        <Separator
          color={AppColors.black_2D2733}
          height={1}
          marginTop={0}
          marginBottom={0}
          marginHorizontal={0}
        />

        {/* step 5 */}
        <View style={{ gap: 12 }}>
          <View style={{ flexDirection: "row", gap: 7 }}>
            <Text style={styles.tooltipStepText}>Step: 5</Text>
            <Text style={styles.tooltipStepHeader}>
              {" "}
              Get URL and Stream Key
            </Text>
          </View>

          {/* 1 */}
          <View style={{ gap: 12 }}>
            <View style={{ flexDirection: "row", gap: 7 }}>
              <Text style={styles.tooltipText}>1.</Text>
              <Text style={styles.tooltipText}>
                Go to the Multiteam Settings in the Kall Out KO platform.
              </Text>
            </View>
          </View>

          {/* 2 */}
          <View style={{ gap: 12 }}>
            <View style={{ flexDirection: "row", gap: 7 }}>
              <Text style={styles.tooltipText}>2.</Text>
              <Text style={styles.tooltipText}>
                Find the URL and Stream Key provided for your target platform.
              </Text>
            </View>
            <TouchableOpacity onPress={() => openModal(5)}>
              <Image
                source={AppImages.icRTMP5}
                style={{
                  width: 251,
                  height: 195,
                  position: "relative",
                }}
                resizeMode="contain"
              />{" "}
              <Image
                source={AppImages.icArrowExpandRound}
                style={{
                  width: 20,
                  height: 20,
                  position: "absolute",
                  left: 10,
                  bottom: 10,
                  tintColor: "#FFFFFF", // Ensure the arrow is white
                }}
                resizeMode="contain"
              />
            </TouchableOpacity>
          </View>
        </View>

        <Separator
          color={AppColors.black_2D2733}
          height={1}
          marginTop={0}
          marginBottom={0}
          marginHorizontal={0}
        />

        {/*step 6 */}
        <View style={{ gap: 12 }}>
          <View style={{ flexDirection: "row", gap: 7 }}>
            <Text style={styles.tooltipStepText}>Step: 6</Text>
            <Text style={styles.tooltipStepHeader}>Configure the Target</Text>
          </View>

          {/* 1 */}
          <View style={{ gap: 12 }}>
            <View style={{ flexDirection: "row", gap: 7 }}>
              <Text style={styles.tooltipText}>1.</Text>
              <Text style={styles.tooltipText}>
                Select the Target Platform from the dropdown menu in OBS.
              </Text>
            </View>
          </View>

          {/* 2 */}
          <View style={{ gap: 12 }}>
            <View style={{ flexDirection: "row", gap: 7 }}>
              <Text style={styles.tooltipText}>2.</Text>
              <Text style={styles.tooltipText}>
                Copy and paste the URL and Stream Key from the Multiteam
                Settings into the respective fields.
              </Text>
            </View>
          </View>
        </View>
      </ScrollView>
      <RtmpStepsSlider
        modalVisible={modalVisible}
        setModalVisible={setModalVisible}
        selectedStep={selectedStep}
      />
    </View>
  );
};

export default RtmpSetupTooltip;

const useStyles = CreateResponsiveStyle(
  {
    tooltipStepText: {
      ...AppFontStyle.REGULAR_ANYBODY_14,
      color: AppColors.gray_C4C4C4,
      minWidth: 50,
    },
    tooltipText: {
      ...AppFontStyle.MEDIUM_ANYBODY_14,
    },
    tooltipStepHeader: {
      ...AppFontStyle.SEMIBOLD_ANYBODY_16,
    },
  },
  {
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.MD]: {},
    [DEVICE_SIZES.SM]: {},
    [DEVICE_SIZES.XS]: {},
  }
);
